module.exports = __webpack_public_path__ + "static/media/supplier-poc.23aef943.svg";